import { render } from "./governancePage.vue?vue&type=template&id=6dc1c765"
import script from "./governancePage.vue?vue&type=script&lang=js"
export * from "./governancePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__